
import {Vue, Component, Prop} from 'vue-property-decorator';

import { Modal } from "@common/Modal";
import i18n from "@service/locale/i18";
import { parseJson } from '@common/TypesHelper';
import { Element } from '@api/models/Element';
import { getImageUrl } from '@common/ImageUrlHelper';
import { RepositoryFabric } from '@api/repositories/RepositoryFabric';
import {ObjectRepository} from "@api/repositories/ObjectRepository";

@Component
export default class ContactsAgreement extends Vue {

    @Prop({ required: true }) objectId: string;
    @Prop({ required: true }) partner: Element;
    @Prop({ required: true }) schemaId: string;

    render() {
        return null;
    }

    async mounted() {
        this.startContactsRequest();
    }

    async startContactsRequest() {

        const alreadyConfirmed = typeof parseJson(localStorage?.getItem(this.lsKey)) === "boolean";

        if(!alreadyConfirmed) {
            const confirmed = await this.doConfirm();

            if(confirmed && confirmed !== "close") {
                this.confirmHandler();
            }
            else if(!confirmed) {
                localStorage?.setItem(this.lsKey, "false");
            }

            this.$emit("close")
        }
    }

    confirmHandler() {
        localStorage?.setItem(this.lsKey, "true");

        this.$repositories.get<ObjectRepository>(RepositoryFabric.OBJECT).create(process.env.VUE_APP_CONTACT_AGREEMENTS_SCHEMA || "ContactAgreements", {
            objectId: this.objectId,
            schemaId: this.schemaId,
            partnerId: this.partner.id,
            userId: this.userId
        });
    }

    get titleTemplate() {

        const logoImageTemplate = this.imageUrl ?
            `<div style="text-align: center; padding-top: 17px; padding-bottom: 15px;">
                <div style="display: inline-block; background-color: white; padding: 15px 26px; text-align: center; border-radius: 8px;">
                    <img style="display: block" src="${this.imageUrl}" alt="logo">
                </div>
            </div>` : "";

        return `
            <div style="font-size: 14px">
                ${logoImageTemplate}
                <p><b>${this.partner.title}</b> ${i18n.t('common.contactsAgreementPart1')}</p>
                <p style="margin-bottom: 0">${i18n.t('common.contactsAgreementPart2')}</p>
            </div>
        `;
    }

    async doConfirm() {
        const modal = new Modal({
            contentText: this.titleTemplate,

            buttons: [
                {
                    text: i18n.t('common.yes').toString(),
                    class: 'is-green is-middle',
                    returnValue: true
                },
                {
                    text: i18n.t('common.no').toString(),
                    class: 'is-red is-middle',
                    returnValue: false
                },
            ]
        });

        return await modal.showConfirm()
    }

    get imageUrl() {
        return getImageUrl(this.backend, this.partner.iconFileId, 64);
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get lsKey() {
        return `${process.env.VUE_APP_SERVER}_contacts-agreement_${this.backend}_${this.userId}_${this.objectId}`;
    }

    get backend() {
        return this.$store.state.session.backend;
    }
}
